import { render } from "./Navbar.vue?vue&type=template&id=1413e441"
import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/Projects/wp_lab/wp-content/plugins/debug-log-config-tool-x/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/components/Navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1413e441"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1413e441', __exports__)) {
    console.log('reload')
    api.reload('1413e441', __exports__)
  }
  
  module.hot.accept("./Navbar.vue?vue&type=template&id=1413e441", () => {
    console.log('re-render')
    api.rerender('1413e441', render)
  })

}


export default __exports__